module.exports = __webpack_public_path__ + "img/share-xing.c5b7627e.png";